import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationKo from './translation.ko';
import translationEn from './translation.en';
import translationJp from './translation.jp.json';
import { getCurrentLang } from '../libs/lang';

const RESOURCE = {
  kr: {
    translation: translationKo,
  },
  en: {
    translation: translationEn,
  },
  ur: {
    translation: translationEn,
  },
  jp: {
    translation: translationJp,
  },
};

i18n.use(initReactI18next).init({
  resources: RESOURCE,
  lng: getCurrentLang(),
  fallbackLng: ['kr'],
  debug: false,
  keySeparator: '.', // we do not use keys in form messages.welcome
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});
export default i18n;
